import type { CheckboxProps } from "@mui/material";
import { Checkbox } from "@mui/material";
import { styled } from "@mui/material/styles";

import variables from "../../../assets/styles/_variables.module.scss";

const SCheckbox = styled((props: CheckboxProps) => <Checkbox {...props} />)(({ theme }) => ({
    "&.MuiCheckbox-root": {
        padding: "0px",
        "&.MuiButtonBase-root": {
            "& svg": {
                fontSize: "1rem",
            },
        },
        "&.Mui-checked": {
            color: variables["primary-purple"],
        },
        "&:hover": {
            backgroundColor: variables["purple-20-op"],
        },
    },
}));

export default function StyledCheckbox(props: Partial<CheckboxProps>) {
    return <SCheckbox {...props} />;
}
